import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import useFaqLink from '../../../hooks/useFaqLink'
import { Constants } from '../../../types'
import Logo from './Logo'

interface HeaderProps {
  language: string
}

const Header = ({ language }: HeaderProps) => {
  const { t, i18n } = useTranslation()
  const targetLanguage = t('common.targetLanguage')

  const needToHelpUrl = `${Constants.Host.Ifinance}/${language}/contact/`
  const faqLink = useFaqLink()

  return (
    <header className="header" style={{ background: 'white' }}>
      <div className="wrap">
        <Logo language={language} />
        <div className="right">
          <a href={faqLink} target="_blank" className="btn-simple" rel="noreferrer">
            {t('common.FAQ')}
          </a>
          <a href={needToHelpUrl} target="_blank" className="btn-simple" rel="noreferrer">
            {t('common.needHelp')}
          </a>

          <button
            type="button"
            style={{ padding: '1rem 2rem' }}
            className="btn btn-blue"
            onClick={() => i18n.changeLanguage(targetLanguage)}
          >
            {targetLanguage}
          </button>
        </div>
      </div>
    </header>
  )
}

export default memo(Header)
